<template>
    <div>
        <nav-bar>
            <button @click="openFilterDialog"><v-icon>{{filterIcon}}</v-icon></button>
        </nav-bar>
        <v-container v-if="error" class="full-height" fill-height fluid>
          <v-row class="text-center"
              justify="center">
              <v-col>{{errorMessage}}</v-col>
          </v-row>
        </v-container>
        <job-list :jobs="filteredJobs"></job-list>
        <v-dialog v-model="filterDialogIsOpen" persistent>
            <v-card>
                <jobs-filter
                        @close="filterDialogIsOpen = false"
                        @filter="filterJobs"
                        :services="services"
                        :stages="stages"
                ></jobs-filter>
            </v-card>
        </v-dialog>
  </div>
</template>

<script>
import { mdiFilter} from '@mdi/js'
import JobList from "../components/JobList";
import NavBar from "../components/NavBar";
import JobsFilter from "../components/JobsFilter";
import {loadJobs} from "../data";

export default {
    name: "Jobs.vue",
    components: {
        NavBar,
        JobList,
        JobsFilter,
    },
    async created() {
        const {data, error} = await loadJobs()
        if (!error) {
            this.jobs = data
        } else {
            this.error = true
            this.errorMessage = error
        }
    },
    data: () => ({
        error: false,
        errorMessage: 'sadas',
        jobs: [],
        filterIcon: mdiFilter,
        filterDialogIsOpen: false,
        selectedStages: [],
        selectedServices: [],
    }),
    methods: {
        openFilterDialog() {
            this.filterDialogIsOpen = true
        },
        filterJobs ({selectedServices, selectedStages}) {
            this.selectedServices = selectedServices
            this.selectedStages = selectedStages
        }
    },
    computed: {
        filteredJobs () {
            return this.jobs.filter(job => {
                const stages = this.selectedStages.includes(job.stage) || this.selectedStages.length === 0
                const services = this.selectedServices.includes(job.service) || this.selectedServices.length === 0
                return stages && services
            })
        },
        services () {
            return Array.from(new Set(this.jobs.map(job => job.service)))
        },
        stages () {
            return Array.from(new Set(this.jobs.map(job => job.stage)))
        }
    }
}
</script>

<style scoped>
.full-height {
    min-height: 100vh;
}
</style>
